export enum VendorUrlType {
  DRAFT_EXPRESS = "DRAFT_EXPRESS",
  PROBALLERS = "PROBALLERS",
  ESPN = "ESPN",
  UNKNOWN = "UNKNOWN",
}

export function vendorUrlType(url: string): VendorUrlType {
  if (url.includes("draftexpress.com")) {
    return VendorUrlType.DRAFT_EXPRESS;
  }
  if (url.includes("proballers.com")) {
    return VendorUrlType.PROBALLERS;
  }
  if (url.includes("espn")) {
    return VendorUrlType.ESPN;
  }

  return VendorUrlType.UNKNOWN;
}

export function isVendorUrl(url: string, vendor: keyof typeof VendorUrlType) {
  return vendorUrlType(url) == vendor;
}
